import { render, staticRenderFns } from "./Infomain.vue?vue&type=template&id=4f022f1a&scoped=true"
import script from "./Infomain.vue?vue&type=script&lang=js"
export * from "./Infomain.vue?vue&type=script&lang=js"
import style0 from "./Infomain.vue?vue&type=style&index=0&id=4f022f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f022f1a",
  null
  
)

export default component.exports